export default {"src":"/_next/static/media/icon-inventory.b3d7f305.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};